{
	"accounts": "Conturi",
	"invitations": "Invitații",
	"subscribeToFeedback": "Înscrie-te în programul de feedback",
	"notificationSettings": {
		"title": "Setări notificări prin e-mail",
		"invoicingInformation": "Informații de facturare",
		"declarationProcessingStatus": "Starea procesării declarației",
		"enabled": "Activat",
		"disabled": "Dezactivat",
		"toast": {
			"success": "Preferința de notificare a fost actualizată",
			"error": "Actualizarea preferinței de notificare a eșuat"
		}
	},
	"about": {
		"title": "Despre",
		"termsAndConditions": "Termeni și condiții",
		"privacyPolicy": "Politica de confidențialitate",
		"imprint": "Mențiuni legale",
		"openSourceAttribution": "Atribuire open source"
	},
	"language": {
		"title": "Limbă",
		"footer": "Schimbările de limbă se vor aplica în toate aplicațiile Heidelberg Materials"
	},
	"impressum": "Mențiuni legale",
	"copyright": "© 2024 Heidelberg Materials. Toate drepturile rezervate.",
	"login": "Autentificare",
	"logout": "Deconectare"
}
